import React, { useEffect, useRef, useState } from "react";

export default function About() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      {
        threshold: 0.65,
        rootMargin: "0px"
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      id="about"
      className="min-h-[50vh] flex flex-col items-center justify-center px-4 md:px-16 py-32"
    >
      <div
        className={`relative max-w-3xl w-full mx-auto bg-black/90 backdrop-blur-sm rounded-2xl border-2 border-[#009726]/40 p-8 transform transition-all duration-1000 ease-out shadow-[0_0_15px_rgba(0,151,38,0.15)] ${
          isVisible 
            ? "translate-x-0 opacity-100" 
            : "-translate-x-full opacity-0"
        }`}
      >
        <h3 className="text-2xl font-mono mb-6 text-center">
          <span className="text-white">&gt; About Me</span>
        </h3>
        
        <p className="text-gray-300 text-base leading-relaxed text-justify mb-8">
        Hello, I’m Aver Godwin. Over the past two years, I’ve been learning and building as a full-stack developer, building from simple web apps to full-scale web3 projects. 
        I enjoy turning ideas into secure, innovative, and user-friendly experiences, and I’m passionate about creating and refining web applications that balance between security, performance, and usability.
         I’m always open to new opportunities, whether that’s a junior or mid-level developer role, or contributing my skills to volunteer projects.
        </p>

        <div className="flex justify-center">
          <button
            onClick={() => window.open('/resume.pdf', '_blank')}
            className="group relative px-5 py-2 bg-black/30 border border-white/20 rounded-lg text-white/90 font-mono transition-all duration-300 flex items-center gap-2 text-sm hover:bg-white hover:text-black hover:border-white"
          >
            <svg 
              className="w-4 h-4" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" 
              />
            </svg>
            Download my resume
          </button>
        </div>
      </div>
    </section>
  );
}